<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";
import axios from "axios";

import su1 from "../results/components/SU1Pie.vue";
import su1Heat from "../results/components/SU1Heat.vue";
import greenDeal from "../results/components/GreenDeal.vue";
import su1SubColumn from "../results/components/SU1SubColumn.vue";
import su1TotalCompletedSurvey from "../results/components/SU1TotalCompletedSurvey.vue";
import wordCloud from "../results/components/WordCloud_su1_1.vue";
import wordCloud1 from "../results/components/WordCloud_su1_2.vue";

import d_SU1SubColumn from "../results/components/d_SU1SubColumn.vue";
import d_SU1Pie from "../results/components/d_SU1Pie.vue";
import d_SU1Heat from "../results/components/d_SU1Heat.vue";
import d_GreenDeal from "../results/components/d_GreenDeal.vue";

export default {
  name: "SDG Alignment Survey Results",
  components: {
    su1,
    su1Heat,
    greenDeal,
    su1SubColumn,
    su1TotalCompletedSurvey,
    wordCloud,
    wordCloud1,
    d_SU1SubColumn,
    d_SU1Pie,
    d_SU1Heat,
    d_GreenDeal,
  },
  data() {
    return {
      textResultsSU1: [],
      loadingTextResultsSU1: false,
      tabsControl: 0,
      textResultsFields: [
        {
          key: "firstname",
          label: i18n.t("su1Results.header.firstname"),
        },
        {
          key: "surname",
          label: i18n.t("su1Results.header.surname"),
        },
        {
          key: "role_name",
          label: i18n.t("su1Results.header.su1TextsAnswer1"),
        },
        {
          key: "su1_texts_answer_1",
          label: i18n.t("su1Results.header.su1TextsAnswer1"),
        },
        {
          key: "su1_texts_answer_2",
          label: i18n.t("su1Results.header.su1TextsAnswer2"),
        },
        {
          key: "completed_on",
          label: i18n.t("su1Results.header.completedOn"),
        },
      ],
      su1PieModal: false,
      su1HeatModal: false,
      greenDealModal: false,
      su1SubColumnModal: false,
      su1TotalCompletedSurveyModal: false,
      wordCloudModal: false,
      wordCloudModal1: false,
      su1Surveys: [],
      selectedSurveyModal: false,
      selectedSurveyID: "",
      selectedSurveyName: "",
      loading: false,

      graphs: true,
      texts: false,

      missingChecks: null,
    };
  },

  watch: {
    selectedSurveyID() {
      const foundSurvey = this.su1Surveys.find(
        (obj) => obj.su1_survey_id == this.selectedSurveyID
      );
      this.selectedSurveyName = foundSurvey.su1_survey_name;
      if (this.selectedSurveyID) {
        this.selectedSurveyModal = false;
        this.textsResults();
      }
    },

    texts(newVal) {
      if (newVal == true) {
        this.textsResults();
      }
    }
  },
  methods: {
    ...mapActions("results", [
      "getTextsResultsByCompanyID",
      "getLastSU1Survey"
    ]),
    ...mapActions("auditor", ["getSU1Surveys"]),
    ...mapActions("reports", ["getGraphImagesInfo"]),

    getMissingGraphs(){
      const params = {
        company_id: Number(sessionStorage.getItem('audited_company_id')),
      }

      this.getGraphImagesInfo(params)
        .then( res => {
          this.missingChecks = res.data.check_images_exist;
        })
    },

    //getsu1surveyTRUE
    getMySurveys() {
      this.su1Surveys = [];
      const params = {
        company_id: Number(sessionStorage.getItem('audited_company_id')),
        is_deleted: false,
      };
      this.getSU1Surveys(params)
        .then((res) => {
          this.su1Surveys = res.data;
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    textsResults() {
      this.textResultsSU1 = [];
      this.loadingTextResultsSU1 = true;
      let params = {
        company_id: Number(sessionStorage.getItem('audited_company_id')),
        su1_survey_id: this.selectedSurveyID,
        is_deleted: "false",
      };
      this.getTextsResultsByCompanyID(params)
        .then((res) => {
          res.data.forEach((element) => {
            this.textResultsSU1.push(element);
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
        .finally(() => {
          this.loadingTextResultsSU1 = false;
        });
    },
    openingSurvey(){
      this.loading = true;
      const params = {
        company_id: Number(sessionStorage.getItem('audited_company_id')),
        created_by: parseInt(this.$user.user_id)
      };

      this.getLastSU1Survey(params)
        .then( res => {
          this.selectedSurveyID = res.data.su1_survey_id;
          this.selectedSurveyName = res.data.su1_survey_name;
        })
        .catch( err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    selectSurvey() {
      this.selectedSurveyModal = true;
    },
    //downloadExcel
    downloadExcel() {
      let params = {
        su1_survey_id: this.selectedSurveyID,
        company_id: Number(sessionStorage.getItem('audited_company_id')),
        created_by: this.$user.user_id,
      };
      axios
        .post(`/api/su1result/getsu1surveyresults`, params, {
          responseType: "blob",
        })
        .then((response) => {
          const url = URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `SDG Alignment Report - ${new Date().toLocaleDateString()}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: response.data,
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },

    handleMyTabs(clickedTab, event){
      if (clickedTab == 0){
        this.graphs = true;
        this.texts = false;
      }
      if (clickedTab == 1){
        this.graphs = false;
        this.texts = true;
      }
    },
  },
  mounted(){
    this.getMySurveys();
    this.openingSurvey();
    this.getMissingGraphs();
    this.textsResults();
  }
};
</script>

<template>
  <div class="p-3">
    <div v-if="loading" class="spinner-container">
      <b-spinner variant="success" label="Loading..."></b-spinner>
    </div>
    <div v-else>
    <div v-if="!selectedSurveyModal">
      <b-button class="m-1 squared-select"
        :variant="selectedSurveyName ? 'success' : 'danger'"
        style="border: 0; max-height: 35px; min-width: 8em"
        @click="selectSurvey()"
      >
        {{ selectedSurveyName ? selectedSurveyName : $t('su1Results.nothing')}}  
      </b-button>
      <b-button class="m-1 squared-select"
        variant="info" style="max-height: 35px;"
        @click="downloadExcel()"
        >{{ $t("su1Results.createExcel") }}
        <b-icon icon="file-earmark-excel"> </b-icon
      ></b-button>
      <br /><br /><br />

      <div class="tab-rounded">
        <div class="tab-btn" :class="{'active': graphs}"
          @click="handleMyTabs(0, $event)"
        >
          {{ $t('su1Results.graphResults') }}
        </div>
        <div class="tab-btn" :class="{'active': texts}" 
          @click="handleMyTabs(1, $event)"
        >
          {{ $t('su1Results.textResults') }}
        </div>
      </div>

      <div v-if="graphs">

        <div class="row">
            <div :class="{'unsaved-graph': !missingChecks.su1_piechart}" class="chart-item m-3 col custom-rounded" style="background: #023047;" > <!--  -->
              <a @click="su1PieModal = true" id="su1-pie">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">
                    {{$t('su1Results.resultsPage.page.sdgAlignment.title')}}
                  </div>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{$t('su1Results.resultsPage.page.sdgAlignment.description')}}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_SU1Pie :selectedSurveyID="selectedSurveyID"/>
                </div>
              </a>
            </div>
          
            <div :class="{'unsaved-graph': !missingChecks.su1_subcolumn}" class="chart-item m-3 col custom-rounded" style="background: #023047" > <!--  -->
              <a @click="su1SubColumnModal = true" id="su1-sub-column">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">
                    {{$t('su1Results.resultsPage.page.sdgSubCol.title')}}
                  </div>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{$t('su1Results.resultsPage.page.sdgSubCol.description')}}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                   <d_SU1SubColumn :selectedSurveyID="selectedSurveyID"/>
                </div>
              </a>
            </div>

            <div class="chart-item m-3 col custom-rounded" style="background: #023047">
              <a @click="su1HeatModal = true" id="su1-heat">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">
                    {{$t('su1Results.resultsPage.page.sdgSubHeat.title')}}
                  </div>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{$t('su1Results.resultsPage.page.sdgSubHeat.description')}}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_SU1Heat :selectedSurveyID="selectedSurveyID"/>
                </div>
              </a>
            </div>
          </div>

          <div class="row">
            <div :class="{'unsaved-graph': !missingChecks.su1_greendeal}" class="chart-item m-3 col custom-rounded" style="background: #023047" > <!--  -->
              <a @click="greenDealModal = true" id="green-deal">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">
                    {{$t('su1Results.resultsPage.page.greenDeal.title')}}
                  </div>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{$t('su1Results.resultsPage.page.greenDeal.description')}}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_GreenDeal :selectedSurveyID="selectedSurveyID" />
                </div>
              </a>
            </div>
            <div :class="{'unsaved-graph': !missingChecks.su1_wordcloud1}" class="chart-item m-3 col custom-rounded" style="background: #023047" > <!--  -->
              <a @click="wordCloudModal = true" id="word-cloud">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">
                    {{$t('su1Results.resultsPage.page.wordCloud_1.title')}}
                  </div>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{$t('su1Results.resultsPage.page.wordCloud_1.description')}}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3 d-flex justify-content-center">
                  <img src="/images/foul.png" alt="" />
                </div>
              </a>
            </div>
            <div :class="{'unsaved-graph': !missingChecks.su1_wordcloud2}" class="chart-item m-3 col custom-rounded" style="background: #023047" > <!--  -->
              <a @click="wordCloudModal1 = true" id="word-cloud-1">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">
                    {{$t('su1Results.resultsPage.page.wordCloud_2.title')}}
                  </div>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{$t('su1Results.resultsPage.page.wordCloud_2.description')}}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3 d-flex justify-content-center">
                  <img src="/images/foul.png" alt="" />
                </div>
              </a>
            </div>
          </div>

      </div>

      <div v-if="texts">
        <b-table
            show-empty
            :busy="loadingTextResultsSU1"
            hover
            responsive
            :fields="textResultsFields"
            :items="textResultsSU1"
          >
            <template #empty="scope">
              <div style="text-align: center; font-size: 20px">
                <span>
                  {{ $t("noData.text") }} <b-icon icon="emoji-frown"></b-icon
                ></span>
              </div>
            </template>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(completed_on)="data">
              <span>
                {{ data.value | dateFormat }}
              </span>
            </template>
          </b-table>
      </div>


      <!-- <b-tabs v-model="tabsControl" content-class="mt-3" justified>
        <b-tab :title="$t('su1Results.graphResults')" active style="background-color: transparent;">
          <br />
          
          
        </b-tab>

        <b-tab :title="$t('su1Results.textResults')">
          
        </b-tab>
      </b-tabs> -->
      <b-modal hide-header hide-footer v-model="su1PieModal" size="xl" centered>
        <div class="modal-content">
          <div class="background-image"></div>
          <b-container class="bv-example-row">
            <b-row class="text-center">
              <b-col cols="12" id="screenshot-area-su1-pie">
                <su-1
                  ref="piecontainer"
                  :selectedSurveyID="selectedSurveyID"
                ></su-1>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-modal>

      <b-modal
        hide-header
        hide-footer
        v-model="su1HeatModal"
        size="xl"
        centered
      >
        <div class="modal-content">
          <div class="background-image"></div>
          <b-container class="bv-example-row">
            <b-row class="text-center">
              <b-col cols="12" id="screenshot-area-su1-heat">
                <su-1-heat
                  :selectedSurveyID="selectedSurveyID"
                  ref="heatcontainer"
                ></su-1-heat>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-modal>

      <b-modal
        hide-header
        hide-footer
        v-model="greenDealModal"
        size="xl"
        centered
      >
        <div class="modal-content">
          <div class="background-image"></div>
          <b-container class="bv-example-row">
            <b-row class="text-center">
              <b-col cols="12" id="screenshot-area-green-deal">
                <div>
                <green-deal
                  ref="greendcontainer"
                  :selectedSurveyID="selectedSurveyID"
                ></green-deal>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-modal>

      <b-modal
        hide-header
        hide-footer
        v-model="su1SubColumnModal"
        size="xl"
        centered
      >
        <div class="modal-content">
          <div class="background-image"></div>
          <b-container class="bv-example-row">
            <b-row class="text-center">
              <b-col cols="12" id="screenshot-area-su1-sub-column">
                <su-1-sub-column
                  ref="subcolcontainer"
                  :selectedSurveyID="selectedSurveyID"
                ></su-1-sub-column>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-modal>

      <b-modal
        hide-header
        hide-footer
        v-model="su1TotalCompletedSurveyModal"
        size="xl"
        centered
      >
        <div class="modal-content">
          <div class="background-image"></div>
          <b-container class="bv-example-row">
            <b-row class="text-center">
              <b-col cols="12" id="screenshot-area-">
                <su-1-total-completed-survey
                  :selectedSurveyID="selectedSurveyID"
                  ref="screenshotContainer4"
                ></su-1-total-completed-survey>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-modal>

      <b-modal
        hide-header
        hide-footer
        v-model="wordCloudModal"
        size="lg"
        centered
      >
        <div class="modal-content">
          <div class="background-image"></div>
          <b-container class="bv-example-row">
            <b-row class="text-center">
              <b-col cols="12" id="screenshot-area-word-cloud">
                <word-cloud
                  :selectedSurveyID="selectedSurveyID"
                  ref="wordcloud1container"
                ></word-cloud>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-modal>
      
      <b-modal
        hide-header
        hide-footer
        v-model="wordCloudModal1"
        size="lg"
        centered
      >
        <div class="modal-content">
          <div class="background-image"></div>
          <b-container class="bv-example-row">
            <b-row class="text-center">
              <b-col cols="12" id="screenshot-area-word-cloud-1">
                <wordCloud1
                  :selectedSurveyID="selectedSurveyID"
                  ref="wordcloud2container"
                />
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-modal>
    </div>
    </div>

    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
      v-model="selectedSurveyModal"
      centered
    >
      <b-container class="bv-example-row">
        <b-row class="text-center">
          <b-col cols="12">
            <b-form-group :label="$t('su1Results.infoTitle')">
              <b-form-select
                :label="$t('registerForm.modalİnputs.companyId')"
                v-model="selectedSurveyID"
                :options="su1Surveys"
                value-field="su1_survey_id"
                text-field="su1_survey_name"
              ></b-form-select> </b-form-group
          ></b-col>
          <b-col cols="12">
            <b-button
              style="float: right"
              size="sm"
              variant="danger"
              @click="selectedSurveyModal=false"
            >
              {{ $t("su1Results.giveup") }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<style scoped>

.tab-rounded {
  border-radius: 200px;
  overflow: hidden;
  border: medium solid var(--sustainfinity-navy);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  margin-bottom: 1em;
}

.tab-btn {
  background-color: whitesmoke;
  color: var(--sustainfinity-navy);
  width: 100%;
  text-align: center;
  padding: .25em;

  transition: all 150ms;
  cursor: pointer;
}

.tab-btn:hover {
  background-color: lightgray;
}

.tab-btn.active {
  background-color: var(--sustainfinity-navy);
  color: whitesmoke;
  pointer-events: none;
}

.save-graph-button{
  position: absolute;
  top: 0;
  right: 0;
  margin: .5em;

  max-width: fit-content;
  max-height: fit-content;

  z-index: 99;
}

.unsaved-graph{
  filter: drop-shadow(0 0 5px red);
}

.modal-content {
  position: relative;
  border: none;
}
.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("/images/sustainfinity_512x512.png");
  opacity: 0.08;
  background-size: cover;
  background-position: center;
}
.background-image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  z-index: -1;
}

table.text-center * {
  text-align: center;
}

@import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
@import url("https://fonts.googleapis.com/css?family=Lato:300,400,700,900&subset=latin-ext");

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

img {
  width: 50%;
  vertical-align: middle;
}

.chart-item a {
  color: #333;
  background: #023047 !important;
  border-radius: 30px !important;
  cursor: pointer;
  font-family: "Lato", sans-serif;
  font-size: 16px;
}

.chart-item {
  box-shadow: 0 0 1em .5em gray;
}

.title{
  color: white !important;
  font-size: 24px;
}
.content > p{
  color: white !important;
}

.squared-select{
  margin-left: .66em !important;
  margin-right: .66em !important;
  text-align: center;

  cursor: pointer;

  border: none;
  outline: none;
  
  color: white;
  font-weight: bold;
  font-size: .9em;

  filter: drop-shadow(0 0 .33em rgb(101, 101, 101));
}
</style>
